// @flow
import { ControlNames } from './constants'
import type { ControlsInfo, ProviderTemplateFieldsInfo } from './types'
import type { ControlVisibility } from './AdEdit'
import _ from 'lodash'

export const ProviderTemplatesToControlsMapping: ProviderTemplateFieldsInfo<string> = {
  vk_column: {
    url: ControlNames.url,
    title: ControlNames.title,
    description: ControlNames.columnDescription,
    image_id: ControlNames.columnImage,
    image: ControlNames.columnImageData,
    image_crop: ControlNames.vkColumnCrop
  },
  vk_multi: {
    url: ControlNames.url,
    title: ControlNames.vkTitle,
    description: ControlNames.vkMultiDescription,
    image_id: ControlNames.multiImage,
    image: ControlNames.multiImageData,
    image_crop: ControlNames.vkMultiCrop,
    link_button: ControlNames.vkLinkButton
  },
  vk_article: {
    url: ControlNames.url,
    title: ControlNames.vkTitle,
    description: ControlNames.vkWithoutButtonDescription,
    image_id: ControlNames.multiImage,
    image: ControlNames.multiImageData,
    image_crop: ControlNames.vkArticleCrop
  },
  vk_promotion: { url: ControlNames.vkUrl },
  vk_site: {
    url: ControlNames.url,
    title: ControlNames.title,
    description: ControlNames.multiDescription,
    link_title: ControlNames.vkLinkTitle,
    image_id: ControlNames.multiImage,
    image: ControlNames.multiImageData,
    logo_image_id: ControlNames.logoImage,
    logo_image: ControlNames.logoImageData,
    logo_image_crop: ControlNames.logoCrop,
    image_crop: ControlNames.vkSiteCrop,
    link_button: ControlNames.vkLinkButton
  },
  vk_video: {
    url: ControlNames.url,
    title: ControlNames.vkTitle,
    description: ControlNames.vkMultiDescription,
    link_button: ControlNames.vkLinkButton,
    video_id: ControlNames.video,
    video: ControlNames.videoData
  },
  vk_leadform: {
    title: ControlNames.vkTitle,
    description: ControlNames.vkMultiDescription,
    image_id: ControlNames.multiImage,
    image: ControlNames.multiImageData,
    image_crop: ControlNames.vkMultiCrop,
    link_button: ControlNames.vkLinkButton
  },
  vk_big_image: {
    url: ControlNames.url,
    title: ControlNames.vkTitle,
    description: ControlNames.vkWithoutButtonDescription,
    snippet_image_id: ControlNames.snippetImage,
    snippet_image: ControlNames.snippetImageData,
    snippet_image_crop: ControlNames.snippetCrop,
    big_image_id: ControlNames.vkBigImage,
    big_image: ControlNames.vkBigImageData,
    link_title: ControlNames.vkLinkTitle,
    link_button: ControlNames.vkLinkButton
  },
  vk_carousel: {
    title: ControlNames.vkTitle,
    description: ControlNames.vkMultiDescription,
    carousel: ControlNames.vkCarousel
  },
  tm_column: {
    url: ControlNames.url,
    title: ControlNames.title,
    description: ControlNames.columnDescription,
    image_id: ControlNames.columnImage,
    image: ControlNames.columnImageData,
    image_crop: ControlNames.tmColumnCrop
  },
  tm_multi: {
    url: ControlNames.url,
    title: ControlNames.title,
    description: ControlNames.multiDescription,
    image_id: ControlNames.multiImage,
    image: ControlNames.multiImageData,
    logo_image_id: ControlNames.logoImage,
    logo_image: ControlNames.logoImageData,
    logo_image_crop: ControlNames.logoCrop,
    small_image_id: ControlNames.tmSmallImage,
    small_image: ControlNames.tmSmallImageData,
    small_image_crop: ControlNames.tmSmallCrop,
    image_crop: ControlNames.tmMultiCrop,
    link_button: ControlNames.tmLinkButton
  },
  tm_product: {
    title: ControlNames.productTitle,
    description: ControlNames.productDescription
  },
  tm_video: {
    url: ControlNames.url,
    title: ControlNames.title,
    description: ControlNames.multiDescription,
    link_button: ControlNames.tmLinkButton,
    video_id: ControlNames.video,
    video: ControlNames.videoData
  },
  tm_carousel: {
    url: ControlNames.url,
    title: ControlNames.title,
    description: ControlNames.tmCarouselDescription,
    logo_image_id: ControlNames.logoImage,
    logo_image: ControlNames.logoImageData,
    logo_image_crop: ControlNames.logoCrop,
    link_button: ControlNames.tmLinkButton,
    carousel: ControlNames.tmCarousel
  },
  tm_promotion: {
    url: ControlNames.tmUrl
  },
  fb_multi: {
    url: ControlNames.url,
    title: ControlNames.fbTitle,
    description: ControlNames.fbMultiDescription,
    image_id: ControlNames.multiImage,
    image: ControlNames.multiImageData,
    instagram_image_id: ControlNames.fbInstagramImage,
    instagram_image: ControlNames.fbInstagramImageData,
    instagram_image_crop: ControlNames.fbInstagramCrop,
    stories_image_id: ControlNames.fbStoriesImage,
    stories_image: ControlNames.fbStoriesImageData,
    stories_image_crop: ControlNames.fbStoriesCrop,
    image_crop: ControlNames.fbMultiCrop,
    link_button: ControlNames.fbLinkButton
  },
  fb_product: {
    title: ControlNames.productTitle,
    description: ControlNames.productDescription
  },
  fb_promotion: { url: ControlNames.fbUrl },
  fb_leadform: {
    title: ControlNames.fbTitle,
    description: ControlNames.fbMultiDescription,
    image_id: ControlNames.multiImage,
    image: ControlNames.multiImageData,
    image_crop: ControlNames.fbMultiCrop,
    link_button: ControlNames.fbLinkButton
  },
  fb_video: {
    url: ControlNames.url,
    title: ControlNames.fbTitle,
    description: ControlNames.fbMultiDescription,
    link_button: ControlNames.fbLinkButton,
    thumbnail_id: ControlNames.fbThumbnailImage,
    thumbnail: ControlNames.fbThumbnailImageData,
    thumbnail_crop: ControlNames.fbThumbnailCrop,
    video_id: ControlNames.video,
    video: ControlNames.videoData
  },
  fb_carousel: {
    url: ControlNames.url,
    title: ControlNames.fbTitle,
    description: ControlNames.fbMultiDescription,
    link_button: ControlNames.fbLinkButton,
    carousel: ControlNames.fbCarousel
  },
  gl_multi: {
    url: ControlNames.url,
    title: ControlNames.title,
    description: ControlNames.multiDescription,
    image_id: ControlNames.multiImage,
    image: ControlNames.multiImageData,
    image_crop: ControlNames.glMultiCrop
  },
  gl_video: {
    url: ControlNames.url,
    title: ControlNames.title,
    description: ControlNames.multiDescription,
    video_id: ControlNames.video,
    video: ControlNames.videoData
  }
}

export function mapProviderTemplatesDataToControlsData(
  providerTemplatesData: ProviderTemplateFieldsInfo<any>,
  initValue: any,
  reduceFunc: (any, any) => any
): ControlsInfo<any> {
  const result = _.fromPairs(_.map(ControlNames, (name) => [name, initValue]))
  _.each(ProviderTemplatesToControlsMapping, (providerTemplateToControls, providerTemplateName) => {
    const providerTemplateData = providerTemplatesData[providerTemplateName]
    if (_.isUndefined(providerTemplateData)) return
    _.map(providerTemplateToControls, (controlName, providerTemplateFieldName) => {
      const fieldData = providerTemplateData[providerTemplateFieldName]
      if (_.isUndefined(fieldData)) return
      result[controlName] = reduceFunc(result[controlName], fieldData)
    })
  })
  return result
}

export function mapControlsDataToProviderTemplatesData(
  controlsData: ControlsInfo<any>
): ProviderTemplateFieldsInfo<any> {
  const result: Object = {}
  _.each(ProviderTemplatesToControlsMapping, (providerTemplateToControls, providerTemplateName) => {
    result[providerTemplateName] = {}
    _.each(providerTemplateToControls, (controlName, providerTemplateFieldName) => {
      result[providerTemplateName][providerTemplateFieldName] = controlsData[controlName]
    })
  })
  return result
}

export function controlVisibilityFromList(list: Array<string>): ControlVisibility {
  const controlNames = _.uniq(
    _.flattenDeep(
      _.map(ProviderTemplatesToControlsMapping, (relations, providerTemplateName: string) => {
        return _.includes(list, providerTemplateName) ? _.values(relations) : []
      })
    )
  )
  const result = {
    ..._.fromPairs(_.map(ControlNames, (name) => [name, _.includes(controlNames, name)])),
    carousel: false,
    // HACK: rely on naming style
    vk: _.some(list, (name) => name.indexOf('vk_') === 0),
    tm: _.some(list, (name) => name.indexOf('tm_') === 0),
    fb: _.some(list, (name) => name.indexOf('fb_') === 0),
    gl: _.some(list, (name) => name.indexOf('gl_') === 0)
  }
  result.carousel = result.vkCarousel || result.tmCarousel || result.fbCarousel

  return result
}
